import React, {useState} from "react";
import moment from "moment";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import {Link} from "react-router-dom";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import avatar_flor from "assets/img/avatar_flor.svg";

import connection from "../../connection";
import general from "../../general";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCheckCircle, faCircle, faClipboardCheck, faEdit, faEye} from "@fortawesome/free-solid-svg-icons";
import SweetAlert from "../../components/SweetAlertWrapper";
import {infoColor} from "../../assets/jss/material-dashboard-pro-react";

import Accordion from "components/Accordion/Accordion.jsx";

import Button from "../../components/CustomButtons/Button";
import EstadoParticipacaoCurso from "../../components/EstadoParticipacaoCurso";
import EstadoParticipacaoModulo from "../../components/EstadoParticipacaoModulo";
import Wizard from "../../components/Wizard/Wizard";
import StateCircle from "../../components/StateCircle";

import AcoesPercurso from "../../other/AcoesPercurso";
import Parser from "html-react-parser";

import AcoesDashboard from "../../other/AcoesDashboard";
import Add from "@material-ui/icons/Add";
import UserSearch from "../../components/UserSearch";
import CardUtilizador from "components/CardUtilizador";
import EstadoUtilizador from "../../components/EstadoUtilizador";
import ListaPagamentos from "../../components/ListaPagamentos/ListaPagamentos";
import ReactTable from "../../components/ReactTableWrapper";
import {SlideDown} from "react-slidedown";
import ExtratoPortaMoedas from "../../components/ExtratoPortaMoedas";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class BaseDashboard extends React.Component {
  constructor(props) {
    super(props);

    if (props.location && props.location.pathname.startsWith("/user-page")) {
      let id_utilizador = props.location && props.location.pathname.split("/user-page/")[1];
      window.App.hist.replace("/perfil/" + id_utilizador);
      this.state = {redirecting: true};
      return;
    }

    let id_utilizador = props.location && props.location.pathname.split("/perfil/")[1];

    let data = props.data ? props.data : {};
    if (data.utilizador)
      id_utilizador = data.utilizador.id;

    this.state = {
      ...data,
      utilizador_proprio: window.App.state.user.id === parseInt(id_utilizador),
      modal: null,
    };

    this.reloadUserDetalhes = () => {
      connection.get("utilizador/perfil", {id: id_utilizador}, (data) => {
        if (!data) {
          general.error("Utilizador não encontrado.", "Erro");
          return;
        }
        this.setState(data)
      });
    };
  }

  componentDidMount() {
    if (!this.props.data && !this.state.redirecting)
      this.reloadUserDetalhes();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data)
      this.setState(this.props.data);
  }

  render() {
    const {classes} = this.props;
    return this.state.utilizador ? (
      <div className={classes.profileContainer}>
        <GridContainer>
          <GridItem xs={12} md={4}>
            <this.UserDetails classes={classes}/>
            {this.state.tutores_atuais && this.state.tutores_atuais.map((tutor_atual) => <this.Tutoria tutor_atual={tutor_atual} historico_tutores={this.state.historico_tutores} titulo={this.state.tutores_atuais.length > 1 ? tutor_atual.grupo_fluxo : ''} classes={classes}/>)}
            {this.state.assistentes_atuais && this.state.assistentes_atuais.map((assistente_atual) => <this.Assistente assistente_atual={assistente_atual} historico_assistentes={this.state.historico_assistentes} titulo={this.state.assistentes_atuais.length > 1 ? assistente_atual.grupo_fluxo : ''} classes={classes}/>)}
            {this.state.tutores_nucleo && this.state.tutores_nucleo.map((tutor_nucleo) => <this.TutorNucleo tutor_nucleo={tutor_nucleo} titulo={this.state.tutores_nucleo.length > 1 ? tutor_nucleo.grupo_fluxo : ''} classes={classes}/>)}
            {this.state.formandos_tutor_grupo_fluxo && this.state.formandos_tutor_grupo_fluxo.map((grupo_fluxo) => <this.FormandosTutor formandos_atuais={this.state.formandos_tutor} historico_formandos={this.state.historico_formandos} grupo_fluxo={grupo_fluxo} titulo={this.state.formandos_tutor_grupo_fluxo.length > 1 ? grupo_fluxo : ''} classes={classes}/>)}
            {this.state.formandos_assistente_grupo_fluxo && this.state.formandos_assistente_grupo_fluxo.map((grupo_fluxo) => <this.FormandosTutor formandos_atuais={this.state.formandos_assistente} historico_formandos={this.state.historico_formandos_assistente} grupo_fluxo={grupo_fluxo} titulo={this.state.formandos_assistente_grupo_fluxo.length > 1 ? grupo_fluxo : ''} classes={classes}/>)}
            {this.state.respostas_formulario.length > 0 && <this.Formularios classes={classes}/>}
            <this.Eventos classes={classes}/>
            <this.Anuncios classes={classes}/>
            {this.state.utilizador_proprio && general.userHasType("chefe_agrupamento", "admin", "chefe_nacional", "secretario_regional") && <this.PercursosContinuos classes={classes}/>}
          </GridItem>
          <GridItem xs={12} md={8}>
            <div style={{marginTop: -15}}>
              {this.state.formacao_continua && <this.FormacaoContinua classes={classes}/>}
              {this.state.acoes && <this.Tarefas classes={classes}/>}
              <this.Percursos classes={classes}/>
              <this.Cursos classes={classes}/>
              <this.Pagamentos classes={classes}/>
              <this.Creditos_Porta_Moedas classes={classes}/>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    ) : (<span>Loading..</span>);
  }

  UserDetails = ({classes}) => <Card profile>
    <CardAvatar profile>
      <a onClick={e => e.preventDefault()}>
        <img src={avatar_flor} alt="..."/>
      </a>
    </CardAvatar>
    <CardBody profile>
      <span className={classes.userNIN}>{this.state.utilizador.NIN}</span>
      <h4 className={classes.cardTitle} style={{textTransform: "capitalize", marginTop: 5}}>
        <EstadoUtilizador nome={this.state.utilizador.nome_curto} estado={this.state.utilizador.estado}/>
      </h4>
      <h6 className={classes.cardCategory}>{this.state.utilizador.email}</h6>
      <GridContainer>
        <GridItem xs={12} sm={4}>
          <h6>Núcleo</h6>
          <span>{this.state.utilizador.nucleo}</span>
        </GridItem>
        <GridItem xs={12} sm={4}>
          <h6>Região</h6>
          <span>{this.state.utilizador.regiao}</span>
        </GridItem>
        <GridItem xs={12} sm={4}>
          <h6>Agrup.</h6>
          <span>{this.state.utilizador.agrupamento}</span>
        </GridItem>
      </GridContainer>
    </CardBody>
  </Card>;

  Formularios = ({classes}) => <Card>
    <CardHeader color="primary">
      <h4 className={classes.cardIconTitle}>Formulários</h4>
    </CardHeader>
    <CardBody style={{padding: 0}}>
      {this.state.respostas_formulario.map((submissao) => <a key={submissao.id} className={classes.submissaoLista + (submissao.data_submissao ? " visto" : "")} href={(() => {
        let url = `/formulario/${submissao.etiqueta}?utilizador=` + this.state.utilizador.id;
        if (!submissao.extra)
          return url;
        if (['PEI', 'PEII', 'PEIII', 'PEIV'].includes(submissao.extra.grupo_fluxo))
          url += "&grupo_fluxo=" + submissao.extra.grupo_fluxo;
        else if (submissao.extra.id_percurso)
          url += "&id_percurso=" + submissao.extra.id_percurso;

        return url;
      })()}>
        <p className={"top"}>
          <span className={"subject"}>{submissao.designacao}</span>
          {(submissao.data_submissao || submissao.abstrato !== 0) ? null : (<FontAwesomeIcon icon={faCircle}/>)}
        </p>
        {[
          submissao.data_rejeicao && <p className={"bottom"}>
            <span className={"date"}>Rejeitado em: {moment(submissao.data_rejeicao).format("DD/MM/YYYY [às] H:mm")}</span>
          </p>,
          submissao.data_validacao && <p className={"bottom"}>
            <span className={"date"}>Validado em: {moment(submissao.data_validacao).format("DD/MM/YYYY [às] H:mm")}</span>
          </p>,
          submissao.data_submissao && <p className={"bottom"}>
            <span className={"date"}>Submetido em: {moment(submissao.data_submissao).format("DD/MM/YYYY [às] H:mm")}</span>
          </p>,
          submissao.data_atualizacao && <p className={"bottom"}>
            <span className={"date"}>Atualizado em: {moment(submissao.data_atualizacao).format("DD/MM/YYYY [às] H:mm")}</span>
          </p>,
          <p className={"bottom"}>
            <span className={"date"}>Preenchimento pendente</span>
          </p>
        ].filter(Boolean)[0]}
      </a>)}
    </CardBody>
  </Card>;

  Eventos = ({classes}) => <Card>
    <CardHeader color="primary">
      <h4 className={classes.cardIconTitle}>Próximos Eventos</h4>
    </CardHeader>
    {this.state.proximos_eventos.length > 0 ? [
        <table style={{borderCollapse: "collapse", marginTop: 5}}>
          <tbody>
          {this.state.proximos_eventos.map((evento) => {
            return <React.Fragment key={"evento_" + evento.id}>
              <tr>
                <td style={{borderBottom: "1px solid #ececec", padding: 5, textAlign: "right"}}>
                  <span className={classes.cardEventDate}>{moment(evento.data_inicio).format("DD MMMM")}</span>
                  <span className={classes.cardEventDate}>{moment(evento.data_inicio).format("HH[h]mm")}</span>
                </td>
                <td style={{borderBottom: "1px solid #ececec", padding: 5}}>
                  <a className={"clickable"} onClick={() => window.open("/" + evento.tipo + "/" + evento.id)}>
                    <span className={classes.cardEventType}>{general.T(evento.tipo)}</span>
                    <span className={classes.cardEventTitle}>{evento.designacao}</span>
                  </a>
                </td>
              </tr>
            </React.Fragment>
          })}
          </tbody>
        </table>,
        this.state.utilizador_proprio && <div style={{margin: "auto", padding: "5px"}}>
          <Button className={classes.info} size="sm" onClick={() => window.App.hist.push("/formacoes")}>Ver Mais</Button>
        </div>
      ] :
      <CardBody style={{textAlign: "center", padding: "2em 0", color: "#bbbbbb"}}>
        <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem eventos</h5>
        <p>Fique atento</p>
      </CardBody>}
  </Card>;

  Anuncios = ({classes}) => <Card>
    <CardHeader color="primary">
      <h4 className={classes.cardIconTitle}>Anúncios</h4>
    </CardHeader>
    {this.state.anuncios.length > 0 ? [
        <table style={{borderCollapse: "collapse", marginTop: 5}}>
          <tbody>
          {this.state.anuncios.map((anuncio) => {
            return <React.Fragment key={"evento_" + anuncio.formacao}>
              <tr>
                <td style={{borderBottom: "1px solid #ececec", padding: 5, textAlign: "right"}}>
                  <span className={classes.cardPostDate}>{moment(anuncio.data).format("DD MMMM HH[h]mm")}</span>
                </td>
                <td style={{borderBottom: "1px solid #ececec", padding: 5}}>
                  <a className={"clickable"} onClick={() => window.open("/formacao/" + anuncio.formacao)}>
                    <span className={classes.cardPostModule}>{anuncio.modulo}</span>
                  </a>
                  <span className={classes.cardPostTitle}>{anuncio.titulo}</span>
                  <span className={classes.cardPostContent}>{Parser(anuncio.conteudo.trim().split("\n").join("<br/>"))}</span>
                </td>
              </tr>
            </React.Fragment>
          })}
          </tbody>
        </table>
      ] :
      <CardBody style={{textAlign: "center", padding: "2em 0", color: "#bbbbbb"}}>
        <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem anúncios</h5>
      </CardBody>}
  </Card>;

  atribuirTutor = (grupo_fluxo) => {
    const {classes} = this.props;
    let tutor = null;

    window.App.openModal(
      <SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Atribuir Tutor ao Formando</span>
        </div>)}
        onConfirm={() => {
          connection.post(`utilizador/alterar/tutor`, {formando: this.state.utilizador.id, tutor: tutor, grupo_fluxo}, (data) => {
            this.reloadUserDetalhes();
            general.success("Tutor atribuído com sucesso.", "Sucesso!");
          });
          window.App.hideModal();
        }}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Atribuir"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Tutor"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              tutor = user.NIN;
            }}
          />
        </form>
      </SweetAlert>
    );
  }

  Tutoria = ({classes, tutor_atual, titulo, historico_tutores}) => {
    historico_tutores = historico_tutores.filter(tutor => tutor.grupo_fluxo === tutor_atual.grupo_fluxo);

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}} className={classes.cardIconTitle}>Tutoria {titulo}</h4>
          {!this.state.utilizador_proprio && general.userHasType("secretario_regional", "admin") && <Button className={classes.button + " " + classes.info} style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}} onClick={() => this.atribuirTutor(tutor_atual.grupo_fluxo)}>
            Alterar Tutor
          </Button>}
        </div>
      </CardHeader>
      <>
        <div style={{margin: "-20px 0 -20px 0"}}><CardUtilizador compact utilizador={tutor_atual} label={tutor_atual.NIN} pode_ver_utilizador={tutor_atual.pode_ver_tutor}/></div>
        {historico_tutores?.length > 0 && <table style={{borderCollapse: "collapse", marginTop: 5}}>
          <thead className={classes.cardPostTitle} style={{fontSize: "1.2em", padding: "10px 0 10px 20px"}}>Histórico de Tutores:</thead>
          <tbody>
          {historico_tutores.map((tutor) => {
            return <React.Fragment key={"evento_" + tutor.id}>
              <tr>
                <td style={{borderTop: "1px solid #ececec", padding: "10px 0 0 20px"}}>
                  <EstadoUtilizador nome={tutor.nome_curto} estado={tutor.estado}/>
                </td>
              </tr>
              <tr>
                <td style={{borderBottom: "1px solid #ececec", padding: "0 0 10px 20px"}}>
                  <span className={classes.cardPostTitle}>De {moment(tutor.data_atribuicao).format("DD/MM/YYYY")} até {moment(tutor.data_desatribuicao).format("DD/MM/YYYY")}</span>
                </td>
              </tr>
            </React.Fragment>
          })}
          </tbody>
        </table>}
      </>
    </Card>
  };

  atribuirAssistente = (grupo_fluxo) => {
    const {classes} = this.props;
    let assistente = null;

    window.App.openModal(
      <SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Atribuir Assistente ao Formando</span>
        </div>)}
        onConfirm={() => {
          connection.post(`utilizador/alterar/assistente`, {formando: this.state.utilizador.id, assistente, grupo_fluxo}, (data) => {
            this.reloadUserDetalhes();
            general.success("Assistente atribuído com sucesso.", "Sucesso!");
          });
          window.App.hideModal();
        }}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Atribuir"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Assistente"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              assistente = user.NIN;
            }}
          />
        </form>
      </SweetAlert>
    );
  }

  Assistente = ({classes, assistente_atual, titulo, historico_assistentes}) => {
    historico_assistentes = historico_assistentes.filter(assistente => assistente.grupo_fluxo === assistente_atual.grupo_fluxo);

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}} className={classes.cardIconTitle}>Assistente {titulo}</h4>
          {!this.state.utilizador_proprio && general.userHasType("secretario_regional", "admin") && <Button className={classes.button + " " + classes.info} style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}} onClick={() => this.atribuirAssistente(assistente_atual.grupo_fluxo)}>
            Alterar Assistente
          </Button>}
        </div>
      </CardHeader>
      <>
        <div style={{margin: "-20px 0 -20px 0"}}><CardUtilizador compact utilizador={assistente_atual} label={assistente_atual.NIN} pode_ver_utilizador={assistente_atual.pode_ver_assistente}/></div>
        {historico_assistentes?.length > 0 && <table style={{borderCollapse: "collapse", marginTop: 5}}>
          <thead className={classes.cardPostTitle} style={{fontSize: "1.2em", padding: "10px 0 10px 20px"}}>Histórico de Assistentes:</thead>
          <tbody>
          {historico_assistentes.map((assistente) => {
            return <React.Fragment key={"evento_" + assistente.id}>
              <tr>
                <td style={{borderTop: "1px solid #ececec", padding: "10px 0 0 20px"}}>
                  <EstadoUtilizador nome={assistente.nome_curto} estado={assistente.estado}/>
                </td>
              </tr>
              <tr>
                <td style={{borderBottom: "1px solid #ececec", padding: "0 0 10px 20px"}}>
                  <span className={classes.cardPostTitle}>De {moment(assistente.data_atribuicao).format("DD/MM/YYYY")} até {moment(assistente.data_desatribuicao).format("DD/MM/YYYY")}</span>
                </td>
              </tr>
            </React.Fragment>
          })}
          </tbody>
        </table>}
      </>
    </Card>
  };

  TutorNucleo = ({classes, tutor_nucleo, titulo}) => {
    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}} className={classes.cardIconTitle}>Tutor de Núcleo {titulo}</h4>
        </div>
      </CardHeader>
      <div style={{margin: "-20px 0 -20px 0"}}><CardUtilizador compact utilizador={tutor_nucleo} label={tutor_nucleo.NIN} pode_ver_utilizador={tutor_nucleo.pode_ver_tutor_nucleo}/></div>
    </Card>
  };

  FormandosTutor = ({classes, formandos_atuais, historico_formandos, grupo_fluxo, titulo}) => {
    formandos_atuais = formandos_atuais?.filter(formando => formando.grupo_fluxo === grupo_fluxo);
    historico_formandos = historico_formandos?.filter(formando => formando.grupo_fluxo === grupo_fluxo);

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}} className={classes.cardIconTitle}>{this.state.utilizador_proprio ? 'Candidatos' : 'Candidatos do tutor'} {titulo}</h4>
        </div>
      </CardHeader>
      <>
        {formandos_atuais.map((formando) => {
          return <div style={{margin: "-20px 0 -20px 0"}}><CardUtilizador compact utilizador={formando} label={formando.NIN} pode_ver_utilizador={formando.pode_ver_formando}/></div>
        })}
        {historico_formandos?.length > 0 && <table style={{borderCollapse: "collapse", marginTop: 5}}>
          <thead className={classes.cardPostTitle} style={{fontSize: "1.2em", padding: "10px 0 10px 20px"}}>Histórico de Formandos:</thead>
          <tbody>
          {historico_formandos.map((formando) => {
            return <React.Fragment key={"evento_" + formando.id}>
              <tr>
                <td style={{borderTop: "1px solid #ececec", padding: "10px 0 0 20px"}}>
                  <EstadoUtilizador nome={formando.nome_curto} estado={formando.estado}/>
                </td>
              </tr>
              <tr>
                <td style={{borderBottom: "1px solid #ececec", padding: "0 0 10px 20px"}}>
                  <span className={classes.cardPostTitle}>De {moment(formando.data_atribuicao).format("DD/MM/YYYY")} até {moment(formando.data_desatribuicao).format("DD/MM/YYYY")}</span>
                </td>
              </tr>
            </React.Fragment>
          })}
          </tbody>
        </table>}
      </>
    </Card>
  };

  PercursosContinuos = ({classes}) => <Card>
    <CardHeader color="primary">
      <h4 className={classes.cardIconTitle}>Formação Contínua</h4>
    </CardHeader>
    {this.state.percursos_continuos?.length > 0 ? [
        <table style={{borderCollapse: "collapse", marginTop: 5}}>
          <tbody>
          {this.state.percursos_continuos.map((percurso) => {
            return <React.Fragment key={"evento_" + percurso.id}>
              <tr>
                <td style={{borderBottom: "1px solid #ececec", padding: "20px 10px 20px 20px"}}>
                  <span className={classes.cardPostTitle}>{percurso.designacao}</span>
                </td>
                <td style={{borderBottom: "1px solid #ececec", paddingRight: "20px", textAlign: "right"}}>
                  <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} style={{width: "170px", height: "25px"}} onClick={() => this.inscreverFormando(percurso.id)}>
                    <Add/> Adicionar Candidato
                  </Button>
                </td>
              </tr>
            </React.Fragment>
          })}
          </tbody>
        </table>
      ] :
      <CardBody style={{textAlign: "center", padding: "2em 0", color: "#bbbbbb"}}>
        <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Não existem percursos de formação contínua disponíveis</h5>
      </CardBody>}
  </Card>;

  inscreverFormando = (percurso_id) => {
    const {classes} = this.props;

    let formando = null;

    window.App.openModal(
      <SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Inscrever Formando no Percurso</span>
        </div>)}
        onConfirm={() => {
          connection.post("percurso/continuos/participante/inscrever", {percurso: percurso_id, formando: formando}, (data) => {
            general.success("Formando inscrito com sucesso.", "Sucesso!");
          });
          window.App.hideModal();
        }}
        onCancel={() => window.App.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Inscrever"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Formando"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              formando = user.NIN;
            }}
          />
        </form>
      </SweetAlert>
    );
  }

  Cursos = ({classes, cursos, cursos_integrados}) => {
    if (!cursos)
      cursos = this.state.cursos.filter(curso => !curso.formacao_continua);

    return <div style={cursos_integrados ? {marginTop: "-0px"} : {}}>
      {!cursos_integrados && <h3 style={{fontWeight: 500, fontSize: "1.4em", marginTop: 30}}>Os Meus Cursos</h3>}
      <Card style={{minHeight: "20px", overflow: "hidden"}}>
        {(cursos && cursos.length > 0) ?
          <div style={{marginBottom: -1}}>
            <Accordion
              expansionPanelSummaryProps={{
                className: classes.percursosAccordionPanel
              }}
              expansionPanelProps={{
                className: classes.percursosAccordionExpansionPanel
              }}
              collapses={cursos.map((curso) => {
                  if (curso.registo.estado && typeof curso.registo.estado === 'string')
                    curso.registo.estado = JSON.parse(curso.registo.estado);

                  let modulos_obrigatorios = curso.registo.estado ? curso.registo.estado.resultado_modulos.filter(modulo => !modulo.opcional) : [];
                  let modulos_opcionais = curso.registo.estado ? curso.registo.estado.resultado_modulos.filter(modulo => modulo.opcional) : [];
                  return {
                    title: cursos_integrados ? <span>Módulos</span> : <>{curso.designacao}<br/><span className={classes.codigoCurso}>{curso.codigo}</span></>,
                    secondaryTitle: <span style={{textTransform: "uppercase", fontSize: 12}}>{curso.registo.estado ? <EstadoParticipacaoCurso detailed estado={{resultado: curso.registo.estado.resultado}}/> : <StateCircle detailed state={curso.registo.estado_participacao}/>}</span>,
                    content: <CardBody>
                      {curso.registo.estado ? <React.Fragment>
                        {modulos_obrigatorios.length ? <p style={{fontWeight: "bold", textTransform: "uppercase", fontSize: 12}}>Módulos Obrigatórios</p> : null}
                        {modulos_obrigatorios.map((modulo) => {
                          return <div>
                            <div className={classes.emFaltaCheckbox}>
                              <EstadoParticipacaoModulo estado={{resultado: modulo.resultado}}/>
                            </div>
                            <span>{modulo.modulo}{modulo.ultima_participacao && <span> (<a className={"clickable"} onClick={() => window.open("/formacao/" + modulo.ultima_participacao.formacao)}>formação #{general.pad(modulo.ultima_participacao.formacao, 5)}</a>)</span>}</span>
                          </div>
                        })}
                        {modulos_opcionais.length ? <p style={{fontWeight: "bold", textTransform: "uppercase", fontSize: 12, marginTop: 22}}>Módulos Opcionais</p> : null}
                        {modulos_opcionais.map((modulo) => {
                          return <div>
                            <div className={classes.emFaltaCheckbox}>
                              <EstadoParticipacaoModulo estado={{resultado: modulo.resultado}}/>
                            </div>
                            <span>{modulo.modulo}{modulo.ultima_participacao && <span> (<a className={"clickable"} onClick={() => window.open("/formacao/" + modulo.ultima_participacao.formacao)}>formação #{general.pad(modulo.ultima_participacao.formacao, 5)}</a>)</span>}</span>
                          </div>
                        })}
                      </React.Fragment> : <h4 style={{marginTop: 0}}>O estado será apresentado em breve.</h4>}
                      {!curso.formacao_continua && <div style={{textAlign: "center"}}>
                        <Button className={classes.info} size="sm" onClick={() => window.App.hist.push("/curso/" + curso.id)}>Ver detalhes do curso</Button>
                      </div>}
                    </CardBody>
                  };
                }
              )}
            />
          </div> :
          <React.Fragment>
            <CardHeader color="primary">
              <h4 className={classes.cardIconTitle}>Os seus cursos serão apresentados aqui</h4>
            </CardHeader>
            <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
              <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Ainda não está inscrito em nenhum curso</h5>
            </CardBody>
          </React.Fragment>}
      </Card>
    </div>;
  }

  Percursos = ({classes}) => {
    let Cursos = this.Cursos;

    if (this.state.percursos.length === 0)
      return <div>
        <h3 style={{fontWeight: 500, fontSize: "1.4em", marginTop: 30}}>O seu percurso</h3>
        <Card style={{minHeight: "20px", overflow: "hidden"}}>
          <CardHeader color="primary">
            <h4 className={classes.cardIconTitle}>O seu percurso irá aparecer aqui</h4>
          </CardHeader>
          <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
            <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Ainda não tem nenhum percurso associado</h5>
            <p>Se tiver dúvidas contacte o chefe de agrupamento</p>
          </CardBody>
        </Card>
      </div>;
    return this.state.percursos.map((percurso) => {
      let active_panels = [];
      let detalhes_fases = percurso.progresso?.map((progresso, index) => {
        let todos_feitos = progresso.fases.filter((fase) => fase.estado === "feito").length === progresso.fases.length;
        let em_progresso = !!progresso.fases.find((fase) => fase.estado === "em_progresso");
        let estado = todos_feitos ? <span style={{color: "#2cc128"}}>Concluído</span> : (em_progresso ? "A Decorrer" : "Pendente");
        let primeiro_progresso = progresso.fases.find((fase) => fase.passos.find(passo => passo.acao)) || progresso.fases.find((fase) => fase.estado === 'em_progresso') || progresso.fases[0];
        let activeId = primeiro_progresso.designacao + primeiro_progresso.subtitulo;

        if (!todos_feitos && em_progresso)
          active_panels.push(index);

        return {
          todos_feitos,
          em_progresso,
          estado,
          primeiro_progresso,
          activeId
        }
      });

      let estado_participacao = percurso.estado_percurso === 'TERMINADO' ? 'Qualificado' : 'Não qualificado';

      return <div key={"percurso_" + percurso.id}>
        <h3 style={{fontWeight: 500, fontSize: "1.4em", marginTop: 30, marginBottom: 0}}>O seu {percurso.designacao} </h3>
        <h5 style={{fontWeight: 500, fontSize: "1.0em", marginTop: 0, color: "gray"}}>{percurso.codigo_percurso} {percurso.data_relatorio_aceite ? ('(' + estado_participacao + ', ' + percurso.relatorio_os + ')') : ''}</h5>
        <Card style={{minHeight: "20px", overflow: "hidden"}}>
          <div style={{marginBottom: -1}}>
            <Accordion
              active={active_panels}
              expansionPanelSummaryProps={{
                className: classes.percursosAccordionPanel
              }}
              expansionPanelProps={{
                className: classes.percursosAccordionExpansionPanel
              }}
              collapses={percurso.progresso?.map((progresso, index) => {
                  return {
                    title: progresso.designacao,
                    secondaryTitle: <span style={{textTransform: "uppercase", fontSize: 12}}>{detalhes_fases[index].estado}</span>,
                    content: <CardBody style={{paddingTop: 0, paddingBottom: 10}}>
                      {progresso.fases.length > 1 ? <Wizard
                        steps={progresso.fases.map(fase => {
                          let tem_acao = !!fase.passos.find(passo => passo.acao);
                          return {
                            stepName: <span style={{color: fase.estado === 'em_progresso' ? "green" : null}}><strong>{fase.designacao}</strong> {fase.subtitulo}{tem_acao && this.state.utilizador_proprio && <span style={{display: "inline-block", height: 5, width: 5, background: "#ff8d00", borderRadius: "50%", marginBottom: 6, marginLeft: 3}}/>}</span>,
                            stepComponent: () => <ProgressoFasesPassos percurso={percurso} fase={fase} utilizador_proprio={this.state.utilizador_proprio} utilizador={this.state.utilizador} classes={classes} reloadData={this.reloadUserDetalhes}/>,
                            stepId: fase.designacao + fase.subtitulo
                          }
                        })}
                        defaultStep={detalhes_fases[index].activeId}
                      /> : <ProgressoFasesPassos fase={progresso.fases[0]} percurso={percurso} utilizador_proprio={this.state.utilizador_proprio} utilizador={this.state.utilizador} classes={classes} reloadData={this.reloadUserDetalhes}/>}
                    </CardBody>
                  };
                }
              )}
            />
          </div>
        </Card>
        {!!percurso.formacao_continua && <Cursos classes={classes} cursos={this.state.cursos.filter(curso => curso.formacao_continua && curso.percurso === percurso.percurso_id)} cursos_integrados={percurso.formacao_continua}/>}
      </div>
    });
  };

  FormacaoContinua = ({classes}) => {
    // Verificar se o utilizador é formador
    let e_formador = this.state.utilizador_proprio && general.userHasType("formador", "diretor_formacao");

    return <div>
      <h3 style={{fontWeight: 500, fontSize: "1.4em", marginTop: 30}}>Formação Contínua{this.state.formacao_continua.resultado === 'OK' && <FontAwesomeIcon icon={faCheckCircle} color={"#16924a"} style={{fontSize: 15, marginBottom: 1, marginLeft: 5}}/>}</h3>
      <GridContainer style={{marginBottom: 20, marginTop: 20}}>
        <GridItem xs={12} sm={e_formador ? 3 : 4}>
          <Card className={classes.cardFormacaoContinua} style={{minHeight: "120px"}}>
            <CardBody>
              <span>Os Meus Créditos</span>
              <h4>{(this.state.formacao_continua.ciclo_ativo.creditos)}</h4>
            </CardBody>
          </Card>
        </GridItem>
        {e_formador && <GridItem xs={12} sm={3}>
          <Card className={classes.cardFormacaoContinua} style={{minHeight: "120px"}}>
            <CardBody>
              <span>Créditos Formação Dinamizada</span>
              <h4>{(this.state.formacao_continua.ciclo_ativo.creditos_como_formador)}</h4>
            </CardBody>
          </Card>
        </GridItem>}
        <GridItem xs={12} sm={e_formador ? 3 : 4}>
          <Card className={classes.cardFormacaoContinua} style={{minHeight: "120px"}}>
            <CardBody>
              <span>Créditos em Falta</span>
              <h4>{(this.state.formacao_continua.ciclo_ativo.creditos_em_falta)}</h4>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={e_formador ? 3 : 4}>
          <Card className={classes.cardFormacaoContinua} style={{minHeight: "120px"}}>
            <CardBody>
              <span>Fim do Ciclo</span>
              <h4>{moment(this.state.formacao_continua.ciclo_ativo.fim).format("DD [de] MMM, YYYY")}</h4>
            </CardBody>
          </Card>
        </GridItem>
        {this.state.formacao_continua.modulos_necessarios.length > 0 && <GridItem xs={12} sm={12}>
          <Card style={{minHeight: "20px", overflow: "hidden", margin: 0}}>
            <div style={{marginBottom: -1}}>
              <Accordion
                expansionPanelSummaryProps={{
                  className: classes.percursosAccordionPanel
                }}
                expansionPanelProps={{
                  className: classes.percursosAccordionExpansionPanel
                }}
                collapses={[{
                  title: "Participação nos módulos",
                  secondaryTitle: <span style={{textTransform: "uppercase", fontSize: 12}}>{<EstadoParticipacaoCurso detailed estado={{resultado: {codigo: this.state.formacao_continua.resultado}}}/>}</span>,
                  content: <CardBody>
                    <p style={{fontWeight: "bold", textTransform: "uppercase", fontSize: 12}}>Módulos Obrigatórios</p>
                    {this.state.formacao_continua.modulos_necessarios.map((modulo) => {
                      return <div style={{display: "flex", alignItems: "top"}}>
                        <div className={classes.emFaltaCheckbox}>
                          <EstadoParticipacaoModulo estado={modulo}/>
                        </div>
                        <span style={{marginBottom: 10}}>
                            {modulo.designacao}<br/>
                          {modulo.resultado.codigo === 'EXP' ?
                            <small>Participação expirada</small>
                            : modulo.data_participacao ?
                              <small>Data de participação: {general.Renderers.dateRenderer(modulo.data_participacao, {date_only: true, hide_timezone: true})}{modulo.validade_creditos && <span>, válido até {general.Renderers.dateRenderer(modulo.validade_creditos, {date_only: true, hide_timezone: true})}</span>}</small> :
                              <small>Limite para participação: {general.Renderers.dateRenderer(modulo.limite_participacao, {date_only: true, hide_timezone: true})}</small>}
                          </span>
                      </div>
                    })}
                  </CardBody>
                }]}
              />
            </div>
          </Card>
        </GridItem>}
      </GridContainer>
    </div>
  };

  Pagamentos = ({classes}) => <Card style={{marginTop: 30}}>
    <CardHeader color="primary">
      <h4 className={classes.cardIconTitle}>Pagamentos Pendentes</h4>
    </CardHeader>
    {this.state.pagamentos_pendentes.length > 0 ? [
        <table className={classes.tabelaPagamentos}>
          <tbody>
          <ListaPagamentos
            pagamentos={this.state.pagamentos_pendentes}
            atualizar={() => this.reloadUserDetalhes()}
          />
          </tbody>
        </table>,
        this.state.utilizador_proprio && <div style={{margin: "auto", padding: "5px"}}>
          <span className="clickable" onClick={() => window.App.hist.push("/pagamentos")} style={{padding: 5, display: "inline-block", color: "#999999", fontWeight: 500}}>Ver Mais</span>
        </div>
      ] :
      <CardBody style={{textAlign: "center", padding: "4em 0", color: "#bbbbbb"}}>
        <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem pagamentos</h5>
        <p>Os seu histórico de pagamentos será apresentado aqui</p>
        <div style={{margin: "auto", padding: "5px"}}>
          <span className="clickable" onClick={() => window.App.hist.push("/pagamentos")} style={{padding: 5, display: "inline-block", color: "#999999", fontWeight: 500}}>Ver Todos</span>
        </div>
      </CardBody>}
  </Card>;

  Creditos_Porta_Moedas = ({classes}) => <Card style={{marginTop: 30}}>
    <CardHeader color="primary">
      <h4 className={classes.cardIconTitle}>Porta Moedas</h4>
    </CardHeader>
    {this.state.credito_porta_moedas.length > 0 ? <ReactTable
      data={this.state.credito_porta_moedas}
      minRows={1}
      SubComponent={(row) => <SlideDown className={'my-dropdown-slidedown'}>
        {row.original.extrato && <div className={classes.wrapper}>
          <ExtratoPortaMoedas stories={JSON.parse(row.original.extrato).map((e, i) => {
            return {
              inverted: false,
              estado: e.acao,
              designacao: e.designacao,
              saldo_inicial: e.saldo_inicial,
              valor: e.valor,
              saldo_final: e.saldo_final,
              data: e.data,
              descricao: e.descricao
            };
          })}></ExtratoPortaMoedas>
        </div>}
      </SlideDown>}
      columns={[
        {
          Header: "Nome",
          accessor: "nome_curto",
          maxWidth: 400,
          Cell: (row) => <span>
                    <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <span style={{fontSize: 10, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.agrupamento + (row.original.nucleo ? " / " + row.original.nucleo : '') + (row.original.regiao ? " / " + row.original.regiao : '')}</span>
                  </span>
        },
        {
          Header: "Região",
          accessor: "regiao_credito",
          maxWidth: 200
        },
        {
          Header: "Saldo",
          Cell: ({original}) => <span>{original.saldo.toFixed(2) + "€"}</span>,
          sortable: true,
          maxWidth: 100
        }
      ]}
      defaultPageSize={10}
      showPaginationBottom={true}
      className="-striped -highlight"
    /> : <CardBody style={{textAlign: "center", padding: "4em 0", color: "#bbbbbb"}}>
      <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Sem créditos no porta moedas</h5>
      <p>Os seu histórico de créditos será apresentado aqui</p>
    </CardBody>}
  </Card>;

  Tarefas = ({classes}) => <div>
    <h3 style={{fontWeight: 500, fontSize: "1.4em", marginTop: 30}}>As minhas Tarefas</h3>
    <Card style={{minHeight: "20px", overflow: "hidden"}}>
      {(this.props.acoes && this.props.acoes.length > 0) ?
        <div style={{marginBottom: -1}}>
          <Accordion
            active={Object.keys(this.props.acoes).map(a => parseInt(a))}
            expansionPanelSummaryProps={{
              className: classes.percursosAccordionPanel
            }}
            expansionPanelProps={{
              className: classes.percursosAccordionExpansionPanel
            }}
            collapses={this.props.acoes.map(acao => {
                let _acao = AcoesDashboard[acao.action];
                if (!_acao)
                  return null;
                return {
                  title: _acao.title,
                  secondaryTitle: <span style={{textTransform: "uppercase", fontSize: 10, color: "#16924a", fontWeight: 400}}>{acao.data.length} tarefa{acao.data.length === 1 ? "" : "s"} por executar</span>,
                  content: <BlocoTarefas description={_acao.description} rows={acao.data} callback={_acao.callback} classes={classes} reloadAcoes={this.props.reloadAcoes}/>
                };
              }
            ).filter(a => a)}
          />
        </div> :
        <React.Fragment>
          <CardHeader color="primary">
            <h4 className={classes.cardIconTitle}>As suas tarefas pendentes serão apresentadas aqui</h4>
          </CardHeader>
          <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
            <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Não tem tarefas por efetuar :D</h5>
          </CardBody>
        </React.Fragment>}
    </Card>
  </div>;
}

class BlocoTarefas extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <CardBody>
      {this.props.description && <p className={classes.tarefasInstrucoes}>{this.props.description}</p>}
      {this.props.rows.map((row, idx) => <div className={classes.tarefasRow}>
        <p>{row.designation}</p>
        <p>{row.date ? moment(row.date).format("D MMMM YYYY") : ''}
          <Button
            justIcon
            onClick={() => {
              // Chamar ação e recarregar listagem no fim
              this.props.callback(classes, row, this.props.reloadAcoes)
            }}
            color="info"
            size={"sm"}
          >
            <FontAwesomeIcon icon={faClipboardCheck}/>
          </Button>
        </p>
      </div>)}
    </CardBody>;
  }
}

class ProgressoFasesPassos extends React.Component {
  constructor(props) {
    super(props);
  }

  sendState() {
    return this.state;
  }

  mostrarDetalhes = async ({ficheiro, html_src}) => {
    let html;
    if (html_src)
      html = await connection.get(html_src);

    window.App.openModal(<SweetAlert
      showClose
      style={{width: 700}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={this.props.classes.modalCardTitle}>Ver documento</span>
      </div>)}
      onCancel={() => window.App.hideModal()}
      cancelBtnText="Fechar"
      showCancel
      closeOnClickOutside={true}
      showConfirm={false}
      cancelBtnCssClass={
        this.props.classes.button
      }
    >
      {ficheiro && <div style={{paddingBottom: "100%", position: "relative"}}>
        <iframe width="100%" style={{border: 0, position: "absolute", top: 0, bottom: 0, left: 0, right: 0, height: "100%"}} src={connection.getFullUrl(ficheiro) + "#view=Fit&navpanes=0"}/>
      </div>}
      {html && Parser(html, {
        replace: domNode => {
          if (domNode.name === 'body')
            domNode.name = "div";
        }
      })}
    </SweetAlert>);
  }

  alterarPercursoEducadores = async (fluxo_escolhido_atual) => {
    const {classes} = this.props;

    let alterar_pe = {
      grupo_fluxo_atual: fluxo_escolhido_atual,
      novo_grupo_fluxo: null
    };

    let novo_grupo_fluxo = null;
    let percursos_de_educadores = await connection.get("percurso/listagem_tipos", {apenas_percurso_educadores: true});
    percursos_de_educadores = percursos_de_educadores.filter(percurso => percurso.codigo !== fluxo_escolhido_atual);

    let Content = () => {
      const [novo_grupo_fluxo_state, setNovoGrupoFluxoState] = useState(alterar_pe.novo_grupo_fluxo);

      return <form autoComplete="off" style={{padding: "0 10px"}}>
        <div style={{marginTop: 30}}>
          <h4>Para qual Percurso de Educadores deseja mover sua inscrição?</h4>
          <p>
            Escolha um dos percursos abaixo e clique em "Confirmar". O fluxo atual será cancelado e será inscrito no novo percurso escolhido.
          </p>
        </div>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
            Percurso de Educadores
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={novo_grupo_fluxo_state}
            onChange={(event) => {
              //novo_grupo_fluxo = event.target.value;
              alterar_pe.novo_grupo_fluxo = event.target.value;
              setNovoGrupoFluxoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o percurso de educadores</MenuItem>
            {percursos_de_educadores.map((percurso) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={percurso.codigo}>{percurso.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </form>;
    };

    window.App.openModal(
      <SweetAlert
        showClose
        style={{width: 700}}
        title={(<h5 style={{fontSize: "1em"}}>Alterar Percurso de Educadores</h5>)}
        onConfirm={async () => {
          await connection.post(`dashboard/alterar_percurso_educadores`, alterar_pe);
          general.success("Alteração de PE realizada com sucesso");
          window.App.hideModal();
          reloadActions(true);
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Agora Não"
        showCancel
      >
        <Content/>
      </SweetAlert>
    );
  }

  render() {
    const {classes, fase, utilizador, reloadData, utilizador_proprio, percurso} = this.props;
    return fase.passos.map((passo) => {
      if (!passo.descricao)
        return null;

      //let acao = passo.acao && AcoesPercurso[percurso.grupo_fluxo + "." + passo.acao];
      let acao = passo.acao && (AcoesPercurso[percurso.grupo_fluxo])[passo.acao];

      return (<div style={{display: "flex", alignItems: "center"}}>
        <div className={classes.emFaltaCheckbox + " " + passo.estado}><FontAwesomeIcon icon={faCheck}/></div>
        <span style={{flex: 1}}>{passo.descricao}
          {utilizador_proprio && passo.extra?.fluxo_escolhido && <a style={{cursor: "pointer", marginLeft: 5}} onClick={() => this.alterarPercursoEducadores(passo.extra.fluxo_escolhido)}>
            <FontAwesomeIcon color={infoColor} icon={faEdit}/>
          </a>}
          {passo.extra?.ficheiro && <a style={{cursor: "pointer", marginLeft: 5}} onClick={() => this.mostrarDetalhes({ficheiro: passo.extra?.ficheiro.path})}>
            <FontAwesomeIcon color={infoColor} icon={faEye}/>
          </a>}
          {passo.extra?.id_resposta && <Link to={"/formulario/ver?submissao=" + passo.extra?.id_resposta + "&utilizador=" + utilizador.id} target={"_blank"}><a style={{marginLeft: 5}} href={"/formulario/ver?submissao=" + passo.extra?.id_resposta + "&utilizador=" + utilizador.id}>
            <FontAwesomeIcon color={infoColor} icon={faEye}/>
          </a></Link>}
            </span>
        {utilizador_proprio && acao && <Button className={classes.info} size="sm" onClick={() => acao.callback(classes, utilizador, {...passo, id_percurso: percurso.percurso_id}, reloadData)}>{acao.text}</Button>}
      </div>)
    });
  }
}

export default withStyles(userProfileStyles)(BaseDashboard);
